import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Button, Chip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { statusToColor, translateStatus } from 'src/pages/sendout/commonUtils';
import {
  HandoverItemType,
  NotificationStatus,
  ProtocolNotifications,
} from 'src/types/handover';
import { getParticipantDisplayName } from 'src/utils/participantUtils';
import { SENDOUT_NAMESPACE } from 'src/i18n';
import { useTranslation } from 'react-i18next';

dayjs.extend(utc);

interface IProps {
  notifications: ProtocolNotifications[];
  itemData: {
    itemType: HandoverItemType;
    handoverId: string;
    publicLinks: string[];
  };
  cancelNotification: (id: string) => void;
}

const NotificationsTableMobile: React.FC<IProps> = ({
  notifications,
  cancelNotification,
}) => {
  const { t } = useTranslation(SENDOUT_NAMESPACE);
  const cancel = (n: ProtocolNotifications) => {
    cancelNotification(n.id);
  };
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('participants.name')}</TableCell>
            <TableCell>{t('notifications.sendTo')}</TableCell>
            <TableCell>{t('notifications.status.status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notifications.map((n) => {
            const fullName = getParticipantDisplayName(n.participant);

            return (
              <TableRow key={n.id}>
                <TableCell>
                  <div>
                    <div style={{ fontWeight: '600' }}>{fullName}</div>
                    <div style={{ fontSize: '12px' }}>
                      {n.participant?.phone}
                    </div>
                    <div style={{ fontSize: '12px' }}>
                      {n.participant?.email}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                    }}
                  >
                    {n.type === 'sms' ? (
                      <ChatBubbleOutlineOutlinedIcon
                        style={{
                          color: '#588504',
                        }}
                      />
                    ) : (
                      <EmailOutlinedIcon
                        style={{
                          color: '#588504',
                        }}
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <Chip
                    label={translateStatus(n.status,t)}
                    style={{
                      backgroundColor: statusToColor(n.status),
                    }}
                  />
                  {n.status == NotificationStatus.SCHEDULED && (
                    <Button
                      variant="outlined"
                      onClick={() => cancel(n)}
                      style={{
                        marginLeft: '18px',
                        borderRadius: '45px',
                        borderColor: '#000000',
                        color: '#000000',
                        textTransform: 'none',
                      }}
                    >
                        {t('buttons.cancel')}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NotificationsTableMobile;
